import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

export interface Props {
  show: boolean;
  className?: string;
  style?: React.CSSProperties;
  size?: string;
}

export const Spinner: React.FC<Props> = ({ show, style, className, size }) => {
  if (!show) return null;

  const styles: React.CSSProperties = {
    textAlign: 'center',
    ...style,
  };

  return (
    <div style={styles} className={className}>
      <FontAwesomeIcon
        pulse
        icon={faSpinner}
        style={{ fontSize: size || '3em', margin: '.3em' }}
      />
    </div>
  );
};
